import React, { useCallback, useEffect, useState } from 'react'
import Colors from 'utils/Colors'
import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { get, post } from 'services/api'
import _ from 'lodash'
import CircularProgress from '@mui/material/CircularProgress'
import { dateFormats, formatDateTime } from 'utils/functions'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SaveIcon from '@mui/icons-material/Save'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import styles from './styles'

const CommentsSection = ({ review }) => {
  const token = useSelector((state) => state.auth.access_token)

  const [commentsData, setCommentsData] = useState({})
  const [typedComment, setTypedComment] = useState('')
  const [loading, setLoading] = useState(false)
  const [pagesLoaded, setPagesLoaded] = useState(0)

  const classes = styles()

  const submitUrl = 'background-check-comment'
  const requestUrl = 'background-check-comments'
  const bgc = review?.application?.background_check || {}
  const pageSize = 10

  const requestComments = useCallback(async () => {
    setLoading(true)
    const res = await get({
      url: `/background-check-comments?review_uuid=${review.uuid}&background_check_uuid=${bgc.uuid}&size=${pageSize}`,
      token: token,
      quiet: true,
    })

    if (_.isEmpty(res)) {
      return null
    }

    setCommentsData(res)
    setLoading(false)
    setPagesLoaded(1)

    return null
  }, [])

  const requestMoreComments = async () => {
    const res = await get({
      url: `/${requestUrl}?review_uuid=${review.uuid}&background_check_uuid=${bgc.uuid}&page=${
        pagesLoaded + 1
      }&size=${pageSize}`,
      token: token,
      quiet: true,
    })

    if (_.isEmpty(res)) {
      return null
    }

    setCommentsData({ ...res, items: [...commentsData.items, ...res.items] })
    setLoading(false)
    setPagesLoaded(pagesLoaded + 1)

    return null
  }

  useEffect(() => {
    requestComments()
  }, [requestComments])

  const submitComment = async () => {
    const params = {
      review_uuid: review.uuid,
      background_check_uuid: bgc.uuid,
      content: typedComment,
    }
    try {
      await post({
        url: `/${submitUrl}`,
        token,
        data: params,
      })
    } catch (ex) {
      reportError(ex)
      return null
    }

    setTypedComment('')
    return requestComments()
  }

  const showCommentForm = () => (
    <React.Fragment>
      <textarea
        id="justificative"
        type="text"
        placeholder="Escreva um comentário..."
        className={classes.commentTextArea}
        onChange={(event) => setTypedComment(event.target.value)}
      />
      <div className={classes.saveButtonDiv}>
        <Button
          onClick={() => submitComment()}
          className={classes.iconButton}
          startIcon={<SaveIcon fontSize="small" />}
        >
          Salvar comentário
        </Button>
      </div>
    </React.Fragment>
  )

  const commentSectionTip = () => {
    if (review.decision === 'WAITING_DECISION') {
      return 'Use a seção de comentários para adicionar uma nota importante, debater com o time ou levantar evidências, enquanto o caso não está resolvido.'
    }

    const decisonText = {
      APPROVED: { text: 'aprovado', color: Colors.green },
      REPROVED: { text: 'reprovado', color: Colors.red },
      SUSPENDED: { text: 'suspenso', color: Colors.orange },
    }

    const decision = decisonText[review.decision]

    return (
      <React.Fragment>
        O caso está <strong style={{ color: decision.color, fontWeight: 'bold' }}>{decision.text},</strong> portanto não
        pode receber novos comentários.
      </React.Fragment>
    )
  }

  return (
    <Accordion disableGutters square>
      <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon />}>
        <Typography>Comentários {loading ? <CircularProgress size="small" /> : `(${commentsData.total})`}</Typography>
      </AccordionSummary>

      {!loading && (
        <AccordionDetails>
          <div className={classes.accordionDetails}>
            <div><InfoIcon /></div>
            <Typography>{commentSectionTip()}</Typography>
          </div>

          <br></br>
          <Divider />

          {review.decision === 'WAITING_DECISION' ? showCommentForm() : null}

          {_.map(commentsData.items, (comment) => (
            <div
              key={comment.uuid}
              className={classes.commentBaloon}
            >
              <p className={classes.commentParagraph}>{comment.content}</p>
              <p>
                <strong>{comment?.user?.name}</strong>
                {' - '}
                <strong>{comment?.user?.user_role || 'Área desconhecida'}</strong>
                <br />
                <span>{formatDateTime(comment.created, dateFormats.br_date_time)}</span>
              </p>
            </div>
          ))}

          <br/>
          
          {(commentsData?.items?.length || 0) < (commentsData?.total || 0) && (
            <Button onClick={() => requestMoreComments()}><strong>Carregar comentários mais antigos</strong></Button>
          )}
        </AccordionDetails>
      )}
    </Accordion>
  )
}
export default CommentsSection
